import { Cellphone } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import classes from './styles.module.scss'

type Props = {
  orientation?: 'landscape' | 'portrait' | 'both'
  activeCurrency: string
  isLoggedIn?: boolean
}

function Orientation({ orientation = 'both', activeCurrency, isLoggedIn }: Props) {
  const activeColor = isLoggedIn ? classes[activeCurrency as keyof typeof classes] : classes['defaultColor']

  const isPortraitActive = orientation === 'portrait' || orientation === 'both'
  const isLandscapeActive = orientation === 'landscape' || orientation === 'both'

  return (
    <div className={classes.root}>
      <Cellphone className={cx(classes.icon, isPortraitActive ? activeColor : '')} />
      <Cellphone className={cx(classes.icon, classes.landscape, isLandscapeActive ? activeColor : '')} />
    </div>
  )
}

export default Orientation
